
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { GetStaticProps } from 'next'
import useTranslation from 'next-translate/useTranslation'
import React from 'react'

import { getFaq } from '@/api/other/getFaq'
import DomainRegister from '@/components/domain/DomainRegister'
// import LegalSection from '@/components/domain/LegalSection'
import ServiceSection from '@/components/domain/ServiceSection'
import WhyUztelecom from '@/components/domain/WhyUztelecom'
import FaqSection from '@/components/faq/FaqSection'
import BaseLayout from '@/components/layouts/BaseLayout'
import Navbar from '@/components/ui/Navbar'
import { APP_NAME, servicesSlug } from '@/res/consts'
import { NAMESPACE_DOMAIN } from '@/res/namespaces'
import { IFaqDetail } from '@/types/Common'

interface Props {
  faq_info: IFaqDetail[]
}

const DnsPage: React.FC<Props> = ({ faq_info }) => {
  const { t } = useTranslation(NAMESPACE_DOMAIN)

  return (
    <BaseLayout
      seoTitle={t('seo_title')}
      seoDescription={t('seo_description')}
      additionalMetaTags={[
        {
          content: keywords.join(','),
          name: 'keywords',
        },
      ]}
    >
      <Navbar notShowMenuIcon />
      <div className="mt-24">
        <div className="container mb-10 text-center">
          <p className="hr:text-[39px] desktop:text-[34px] laptop:text-[32px] tablet:text-[34px] small:text-[30px] text-[28px] small:leading-10 leading-8  font-bold small:px-10 mb-10">
            {t('find_and_register')}
          </p>
          <span className="hr:text-[22px] hr:leading-4 desktop:leading-4 desktop:text-[20px] laptop:text-base small:text-[18px] text-sm text-[#878D9C] ">
            {t('at_uztelecom', { appName: APP_NAME })}
          </span>
        </div>
        <DomainRegister domain="" />
        <ServiceSection />
        <WhyUztelecom />

        {/* <LegalSection /> */}
        <FaqSection faq_info={faq_info} />
      </div>
    </BaseLayout>
  )
}

 const _getStaticProps: GetStaticProps = async ({ locale }) => {
  const res = await getFaq(servicesSlug.dns, locale as string)

  return {
    props: {
      faq_info: res,
    },
    revalidate: 100,
  }
}

const keywords = [
  'Domain',
  'whois domain',
  'domain uz',
  'buy domain uz',
  'check domain uz',
  'domen uz',
  'domen uzb',
  'uz domen sotib olish',
  'uz domen haqida',
  'дешевые домены уз',
  'домены уз',
  'домены узбекистана',
  'узнать домены на ip',
  'купить домен',
  'где купить домен',
  'Dns uz',
  'Dns Uzbekistan',
  'kupit domen uz',
  'регистрация доменов',
  'занят ли домен',
  'сколько стоит купить домен',
]

export default DnsPage


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/services/dns/index',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  